<template>
    <div class="phone_custom_prompt">
        <p class="phone_custom_status" role="status">{{ empty ? '暂无相关资料' : '已展示全部资料' }}</p>
        <section class="phone_custom_card" aria-label="标书定制服务">
            <div class="phone_custom_intro">
                <span class="phone_custom_mark" aria-hidden="true"><van-icon name="edit" /></span>
                <div>
                    <div class="phone_custom_service">一站式标书定制服务</div>
                    <h3>找不到想要的资料？</h3>
                </div>
            </div>
            <p class="phone_custom_description">可以在线咨询我们，为您量身定制标书 / 方案。</p>
            <van-button class="phone_custom_action" type="info" block to="/phoneCustom">定制需求</van-button>
        </section>
    </div>
</template>

<script>
export default {
    name: 'phoneCustomPrompt',
    props: {
        empty: { type: Boolean, default: false }
    }
}
</script>

<style scoped lang="scss">
.phone_custom_prompt {
    margin: 0.16rem 0 0.1rem;
    color: #333333;
    .phone_custom_status { margin: 0 0 0.14rem; color: #737373; font-size: 0.12rem; text-align: center; }
    .phone_custom_card { padding: 0.2rem; border-radius: 0.1rem; background: #ffffff; }
    .phone_custom_intro { display: flex; align-items: center; }
    .phone_custom_mark { display: inline-flex; flex-shrink: 0; align-items: center; justify-content: center; width: 0.4rem; height: 0.4rem; margin-right: 0.12rem; border-radius: 0.08rem; background: #edf5ff; color: #2080e5; font-size: 0.22rem; }
    .phone_custom_service { color: #737373; font-size: 0.12rem; line-height: 1.5; }
    h3 { margin: 0.04rem 0 0; color: #333333; font-size: 0.16rem; line-height: 1.5; font-weight: 600; }
    .phone_custom_description { margin: 0.14rem 0 0.18rem; color: #666666; font-size: 0.13rem; line-height: 1.8; }
    .phone_custom_action { min-height: 44px; height: 0.44rem; border-radius: 0.06rem; background: #1973d2; border-color: #1973d2; font-size: 0.14rem; }
    .phone_custom_action:focus-visible { outline: 2px solid #155ca8; outline-offset: 3px; }
}
</style>
